<p-card>
    <img src="assets/layout/images/logo.png" height="50">
    <h3>¡Bienvenidos/as!</h3>
    <h4>Esta plantilla tiene los elementos esenciales para comenzar un proyecto en Angular 14 con la libreria <a class="text-blue-500" href="https://www.primefaces.org/primeng/#/">PrimeNG</a> (Basada en su plantilla Manhattan).</h4>
    <h5>Además se han incluído la biblioteca de estilos <a class="text-blue-500" href="https://www.primefaces.org/primeflex/">PrimeFlex</a></h5>
    <p>Para entender como funciona antes debemos saber como esta estructurado el proyecto, el núcleo de desarrollo se encuentra bajo la carpeta <strong>src</strong>. Puedes ver el siguiente esquema y pulsar sobre las carpetas para ver la descripción de cada
        una, o bien pasar a la siguiente sección.</p>
    <div class="grid">
        <div class="col-12 md:col-3 py-0">
            <p-tree [value]="arquitec" selectionMode="single" [(selection)]="selectedNode"></p-tree>

        </div>
        <div class="col-12 md:col-9 p-0">
            <div class="col-12 border-solid border-round-sm border-300 border-1">
                <h6>Descripción de la carpeta</h6>
                {{selectedNode?.data}}
            </div>

        </div>
    </div>
    <div>
        <ul>
            <li>app: Donde se encuentra todo el código de la aplicación:
                <ul>

                    <li>
                        core: El núcleo de la aplicación, todos los servicios, interceptores, guards, el módulo principal y el app.component además de algunos comoponentes que siempre se van a renderizar como la topbar o el menú van bajo esta carpeta.
                        <ul>
                            <li>
                                modules: La carpeta donde incluiremos los módulos de la aplicación los cuales utilizaremos recursivamente. Se han creado dos: El Init de angular, donde se incluyen modulos básicos de angular. Y el init de primeng donde se incluyen todos los modulos de
                                primeng para no tener que importarlo en cada modulo nuevo que creemos.
                            </li>
                            <li>
                                services: Servicios utilizados en la aplicación.
                            </li>
                            <li>
                                login: pantalla de login y auth service
                            </li>
                            <li>
                                guards: Guards de la aplicación, Ej: restringir acceso a componentes por si tiene token o no el usuario
                            </li>
                            <li>
                                interceptors: Interceptores HTTP, sirven para que cada llamada AJAX pase por estos (Se pueden añadir de otros tipos). Ej: Jwt, añade token. Error: Revisa los errores para realizar acciones de "No authorize" u otras.
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
            <li>
                shared: Todos los elementos que van a ser compartidas en la aplicación, componentes, directivas, pipes, helpers y modelos.
                <ul>
                    <li>
                        components: Vistas de nuestra aplicación. Puede ser desde una pantalla completa, a pequeñas secciones de una o varias pantallas.
                    </li>
                    <li>
                        directives: Directivas de la app.
                    </li>
                    <li>
                        models: Modelos/DTO de la app. En angular en vez de DTO se escribe "ClassNameModel" como nombre de la clase y "class-name.model.ts" como nombre de archivo.
                    </li>
                    <li>
                        pipes: Pipes de transformación de datos de la app.
                    </li>
                    <li>
                        utilities: El archivo utils.ts contiene funciones (helpers) las cuáles utilizaremos en diferentes componentes. Incluyen funciones para reiniciar formularios, seleccionar la hora y minutos de un timespan, transformar a date las propiedades que llegan del
                        back sin el formato correcto de un objeto u array, validaciones de formularios de pdf, de tamaño máximo de fichero, progreso de envío de datos...
                    </li>
                </ul>
            </li>
            <li>
                assets: Contiene todos los elementos estáticos de la aplicación, como imagenes, css, etc.
            </li>
            <li>
                enviroments: Variables de entorno, se pueden configurar para crear variables de entorno para pruebas y tests.
            </li>
        </ul>

        <p><strong>Plantilla:</strong> podemos decidir el estilo de la plantilla a partir de los elementos que componen el menú, así como el propio tipo de menú. En el caso de que vayamos a cambiar los estilos css de la aplicación se encuentran en el punto
            de entrada principal de la aplicación <strong>index.html</strong>. Si vamos a cambiar el tipo de menú en el archivo <strong>app.component.ts</strong> hay una variable llamada "menuMode", simplemente hay que cambiarle el valor por el tipo de
            menú que ofrece la plantilla. Por último, si deseamos tener el menú en modo light o dark hay que cambiar el valor booleano de la variable lightMenú, dentro del mismo archivo que el tipo de menú.</p>

    </div>
    <ng-template pTemplate="footer">
        <strong>Versión de plantilla 2.1</strong>
    </ng-template>
</p-card>